export default function ProperlyStoreHarley() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', lineHeight: 1.7 }}>
      <h2>Properly Storing Your Harley</h2>
      <p>
        No one likes to think about cold weather and not riding, but there are
        times when iced roads prevent riding. To help prevent costly start-ups
        after winter storage, here are some questions and answers about how to
        properly store your bike.
      </p>

      <h3>Should I drain my tank?</h3>
      <p>
        <strong>No.</strong> Filling the oil and gas tanks will keep internal
        areas submersed. The less volume of air inside these tanks the less
        chance of condensation forming. Condensation causes rust, and when rust
        forms inside a gas tank, it becomes much more involved to clean and coat
        the inside of the tank to clear up this problem.
      </p>
      <p>
        <em>Note:</em> Most Harley-Davidson® factory installed gas tanks have a
        coating inside the tank to prevent rusting when stored. If your bike has
        a tank liner you do not have to fill the tank with gas. Do add the
        stabilizer, then, come spring, add fresh gas to the existing tank and
        treat new gas with stabilizer.
      </p>
      <p>
        Stored gasoline can go bad in as little as 60 days. Adding a gasoline
        stabilizer will keep the gas inside the tank from going bad for up to a
        year. Run the bike until the stabilized gas is through the carburetor.
        The treated gas will eventually evaporate cleanly without leaving a
        heavy residue behind to gum up jets and passages. As possible, drain the
        carburetor to remove fuel prior to storing, but not all bikes have drain
        plugs on the float bowl. On models without drain plugs we recommend
        turning off the fuel valve and running the bike until it is out of gas.
        The amount of fuel left in the bowl will not be an issue if treated.
        This is also true for fuel injected motorcycles as well. Of course there
        is no bowl to drain but the gas will be usable in the spring. It will
        not be necessary to drain the tank in the spring, just start the bike
        and ride with the treated fuel as usual.
      </p>
      <p>
        We recommend to start using gas stabilizer all year long. The new
        ethanol fuel allows moisture to build up in the gas tank, and does not
        last as long as older formula gasoline. The newly formulated
        stabilizers/conditioners not only prevent the gas from going bad, but
        also break down condensation like a dry gas. This keeps your gas source
        clean and ready when you are.
      </p>
      <p>
        We recommend Liquid Performance Ethanol Equalizer brand stabilizer and
        is always available at our shop.
      </p>

      <h3>How often should I start my bike?</h3>
      <p>
        Don’t start your bike unless you are going to ride it. Most engine wear
        occurs on initial start up. Only start the bike if you intend to go for
        a ride (6 miles or more). Running the bike in the driveway will not
        charge your battery enough from the drain of starting, or warm the
        engine cases enough to remove the condensation that will occur from
        running the bike. Instead of starting the bike, roll the bike in and out
        to position it on a different spot on your tires and turn the engine to
        a different spot to prevent rings from rusting, and valve springs from
        staying open all winter.
      </p>

      <h3>Should I change my oils?</h3>
      <p>
        If your bike is ready for a scheduled service, by all means replace all
        fluids on the bike. Old or contaminated oil will separate and lay on and
        rust parts inside your engine, transmission and primary drive areas. If
        it’s old change it.
      </p>
      <p>
        If you have just done a service in the past 1000 miles or so, let it sit
        until spring and then replace the fluids. It doesn’t go bad in the
        bottle on the shelf; it won’t go bad in the oil tank or transmission on
        the bike.
      </p>

      <h3>Should I clean my bike?</h3>
      <p>
        Yes. Clean your bike prior to storage. We all ride on Ocean Highway
        along Jones Beach. Even if it is a sunny day, the salt air will collect
        on any forward facing part of your motorcycle and begin to eat away at
        the surface. That is why the front sides of all fork legs pit first, as
        do the mirror stems, front turn signal hardware, forward facing surfaces
        of highway pegs, engine guards, cam cover, etc. Even when it rains here,
        it is usually a storm off the ocean bringing salt water with it. There
        is no getting away from the fact that we live on an island surrounded by
        salt water. Even inland it will get to your parts. We recommend a
        product from S100 Corrosion Protectant. S100 is a company that makes an
        extensive line of motorcycle care products. This product sprays on all
        chromed and aluminum surfaces and leaves a coating to insulate the
        surface from the elements. Clean your bike then spray on the S100
        Corrosion Protectant and buff the surface to a gloss finish. This is an
        all year product, use it all the time.
      </p>
      <p>
        If you spray this corrosion protection on and do not buff it to a high
        gloss it will require more elbow grease to remove it in the spring. We
        recommend this in damp areas or when you are forced to store your bike
        outdoors for the winter.
      </p>
      <p>
        It’s ok to wax your bike to clean it, but do not leave wax on your bike.
        Some waxes contain oils that will damage the finish on the paint.
      </p>
      <p>
        Most shops will have a detailer or know of one to recommend. Lots of our
        customers have their bikes detailed. The original opinion was why pay to
        do something that I could do myself. And if you will actually get to do
        it, by all means, clean your bike.
      </p>
      <p>
        However, most long islanders are working 6 days a week and that does not
        leave as much time as you think to spend 4 to 5 hours thoroughly
        cleaning your motorcycle.
      </p>
      <p>
        Some of these Harleys are $20,000 plus to purchase. To let that sit and
        rust is a poor way to maintain your investment.
      </p>
      <p>
        I personally would rather pay someone $200-$250 to clean my bike than to
        lose $1000.00 worth of chrome to pitting from not cleaning it.
      </p>
      <p>
        Do not park your bike against a cement wall, it will be a green rusted
        hulk come springtime. Moisture comes off the cement walls and stays
        captive between your bike and the wall and just ruins everything.
      </p>

      <h3>Should I cover my bike?</h3>
      <p>Yes. Cover your bike.</p>
      <p>
        A good breathable cover will allow the air to circulate through the
        cover and keep all the air in the storage area at the same temperature.
        It will also keep dust, dirt and other contaminants off your bike. It
        may even keep spiders, bugs, moths, mice and birds off your bike and yes
        they love exhaust pipes. You may want to cover the ends of your pipes
        and the intake to prevent rodents from making a home in them. You can
        use rubber work gloves to stretch around the open port or newspaper can
        be stuffed into openings.
      </p>
      <p>
        If you have to store your bike outdoors, coat the bike to prevent rust
        and cover it with a water resistant or water proof cover and check the
        condition throughout the winter.
      </p>
      <p>
        Tie the cover to prevent it from blowing off. Try to get the tires off
        the ground to prevent them from freezing to the surface.
      </p>

      <h3>Should I keep my bike in a shed?</h3>
      <p>
        Any indoor storage is better than no indoor storage. A bike stored in a
        steel shed can rust quickly. Condensation builds because of how rapidly
        the air temperature inside a shed will change when the sun hits it.
      </p>
      <p>
        Rapid temperature change is responsible for causing condensation. Even a
        20-degree shift can easily cause sweating over your entire bike. A
        detached garage will change temperatures faster than an attached garage
        but slower than a shed. If you can insulate a garage it will help
        maintain gradual changes in temperature and prevent condensation. Ideal
        conditions would be a heated garage with dehumidifier to remove excess
        moisture from the area.
      </p>
      <p>
        As an example, you can leave a raw piece of steel in the cold and it
        will not rust, but bring it indoors and the temperature change causes
        the metal to sweat and rust. Whatever you can do to prevent wide swings
        in temperature will help.
      </p>

      <h3>Should I remove my battery for storage?</h3>
      <p>
        If your bike is stored outdoors remove the battery to prevent it from
        freezing. If you ignore your battery and leave it where it can freeze,
        it may do so and crack the case, allowing acid to spill on the bike. If
        even a drop gets on the chain, rear belt or any chrome it can be
        rendered worthless.
      </p>
      <p>
        Maintain your battery. Most batteries today are sealed with little
        liquid acid in them to worry about freezing, so a sealed battery can be
        maintained on the motorcycle.
      </p>
      <p>
        Even if the battery says no maintenance, it still needs to be charged
        once a month.
      </p>
      <p>
        Your battery will lose its static charge in 30 days. The best solution
        to date is a Battery Tender. These are "smart" battery chargers that you
        can leave on the battery all the time. They have microchip technology
        that can determine when the battery is fully charged and will cut the
        charge rate to a "float" charge, below ½ of 1 amp. They are equipped
        with indicator lamps, green for fully charged or red for charging. They
        will even blink to indicate that the battery is 75% charged and has
        enough power to start the bike.
      </p>
      <p>
        If you do not have electric near the bike, you may want to take the
        battery out of the bike and put it on a tender indoors. If you do not
        have a tender, any good 12 volt battery charger that has a maximum
        output of 6-8 amps will do, (the less the better), but do not leave it
        on all day, only a few hours once a month should be enough to maintain a
        battery.
      </p>

      <h3>Do I need to get the tires off the ground?</h3>
      <p>
        For extended storage, more than a year, it is a good idea to support the
        bike from the frame instead of the tires. This removes the load from the
        suspension and prevents flat spots on the tires. For standard Long
        Island winter storage I do not feel it is necessary.
      </p>
      <p>
        You can roll the bike every few weeks so the tires are not in the same
        spot. Make sure the air pressure is correct or slightly higher than
        normal, as the cold weather will cause tire pressure to drop, and check
        them again before the first ride.
      </p>
      <p>However if you do own a lift, I would use it cause "it can’t hurt."</p>

      <h3>Additional Tech Tips:</h3>
      <ol>
        <li>
          Make a list of everything you've done and attach it to a handgrip.
          This list works as reference for getting your bike up to speed in the
          spring.
        </li>
        <li>
          Adding engine oil to the cylinders through the spark plug holes or use
          an engine fogger for longer periods of storage (6 months or more)
          rotate the engine with the plugs out to coat the cylinder walls.
        </li>
        <li>
          Hang a light bulb over your bike. The heat from a standard bulb can
          help displace moisture around the motorcycle.
        </li>
        <li>
          Be careful about covering your bike with a sheet and catching fire. A
          spark from a car style battery charger can set a cloth sheet on fire.
          The Battery Tender brand chargers are spark proof. Even if you touch
          the positive and negative terminals together, or hook it up reversed,
          it will not spark.
        </li>
        <li>
          Now in the winter is the perfect time to call your favorite technician
          and schedule an appointment to get your work done early and be ready
          for spring.
        </li>
      </ol>

      <p>
        If you have any additional questions about proper care of your
        motorcycle, please call us at{' '}
        <a href="tel:516-489-0770">516-489-0770</a> or email{' '}
        <a href="mailto:Salesrtc@optonline.net">Salesrtc@optonline.net</a> and
        we will be happy to answer anything we may have left out.
      </p>
      <p>
        If you are preparing to take your bike out for the first time after
        sitting or after winter storage, here is a pre-ride check list to use to
        be sure your bike is ready:
        <br />
        <a
          href="https://www.msf-usa.org/downloads/BRC_Ultimate_Checklist.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click Here for MSF Pre-Ride check list!
        </a>
      </p>
    </div>
  );
}
